import { SubmissionStatus } from "generated-graphql/graphql";
import {
  partitionSubmissions as partitionSubmissionsGeneric,
  type PartitionedSubmissions as GenericPartitionedSubmissions,
} from "utils/partitionSubmissions";

import { Row } from "./types";

/**
 * Statuses where bulk add reviewers and bulk set signer actions are locked.
 * These submissions are too far in the workflow to allow reviewer/signer changes.
 */
export const BULK_ACTION_LOCKED_STATUSES: SubmissionStatus[] = [
  SubmissionStatus.EncampInitialReview,
  SubmissionStatus.InReview,
  SubmissionStatus.ProcessingSubmission,
  SubmissionStatus.FilingComplete,
];

/**
 * Checks if a submission status is locked for bulk reviewer/signer actions.
 */
export function isSubmissionLockedForBulkAction(
  status: SubmissionStatus | null | undefined
): boolean {
  return status ? BULK_ACTION_LOCKED_STATUSES.includes(status) : false;
}

export type PartitionedSubmissions = GenericPartitionedSubmissions<Row>;

export function partitionSubmissions(submissions: Row[]): PartitionedSubmissions {
  return partitionSubmissionsGeneric(submissions, {
    getFrequency: (row) => row.frequency,
    getSubmissionId: (row) => row.submission?.id,
  });
}

/**
 * Formats a virtual event for display in a data grid
 */
export function formatVirtualEventForGrid(virtualEvent: Row) {
  return {
    id: virtualEvent.id,
    isVirtual: true,
    submission: {
      dueDate: virtualEvent.deadline,
      title: virtualEvent.title,
      submissionType: virtualEvent.submission?.submissionType,
      status: null,
    },
    facilities: virtualEvent.facilities,
  };
}
